export type PortraitProgressStage = 'analyzing' | 'queued' | 'processing' | 'finalizing' | 'completed' | 'failed';

const STAGE_PROGRESS: Record<Exclude<PortraitProgressStage, 'completed' | 'failed'>, { min: number; max: number; seconds: number }> = {
  analyzing: { min: 6, max: 18, seconds: 8 },
  queued: { min: 18, max: 34, seconds: 18 },
  processing: { min: 34, max: 88, seconds: 70 },
  finalizing: { min: 88, max: 97, seconds: 22 }
};

export function estimatePortraitProgress(startedAt: number | undefined, stage: PortraitProgressStage, tick = 0) {
  void tick;
  if (stage === 'completed') return 100;
  if (stage === 'failed') return 0;
  if (!startedAt) return STAGE_PROGRESS[stage].min;

  const elapsedSeconds = Math.max(0, (Date.now() - startedAt) / 1000);
  const phase = STAGE_PROGRESS[stage];
  const eased = 1 - Math.exp(-elapsedSeconds / phase.seconds);
  const progress = phase.min + (phase.max - phase.min) * eased;

  return Math.min(phase.max, Math.max(phase.min, Math.round(progress)));
}
